import { render, staticRenderFns } from "./SingleDashboardEditView.vue?vue&type=template&id=97e18c68&scoped=true&"
import script from "./SingleDashboardEditView.vue?vue&type=script&lang=js&"
export * from "./SingleDashboardEditView.vue?vue&type=script&lang=js&"
import style0 from "./SingleDashboardEditView.vue?vue&type=style&index=0&id=97e18c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e18c68",
  null
  
)

export default component.exports